import React from "react";

import styled from "styled-components";

import { LumenV2Header } from "shared/components/vega/LumenV2";
import { findLumenResult } from "shared/components/vega/LumenV2/utils";

import { CompactLumenRun } from "./CompactLumenRun";

/* Standalone Lumen tab for VERO1 / redesign audiences: run header kept,
   entries in the deal review tab's compact row grammar. Other audiences keep
   the full-size LumenV2 view. */

/* the white card the full-size view gets from the global `vega container` */
const Card = styled.div`
  background: #fff;
`;

const Body = styled.div`
  padding: 6px 18px 16px;
`;

export const CompactLumenTab: React.FC<{
  lumenRun: unknown;
  detailed?: boolean;
}> = ({ lumenRun, detailed = false }) => {
  if (!lumenRun) return null;
  const result = findLumenResult(lumenRun);
  return (
    <Card data-testid="compact-lumen-tab">
      <LumenV2Header lumenRun={lumenRun} result={result} />
      <Body>
        <CompactLumenRun lumenRun={lumenRun} detailed={detailed} />
      </Body>
    </Card>
  );
};
